export const platformSettingsLimits = {
  siteTitle: 64,
  shortTitle: 16,
  browserTitle: 64,
  copyright: 128,
  logoBytes: 1024 * 1024,
  maintenanceMessage: 200,
} as const;
